/* eslint-disable max-params */
import Types from "./types";
import { LeadServiceJava } from "../../../service/lead-service-java-api";

import { carConsumerService } from "../../../service/car-consumer-gateway-api";

const fetchSlotsSuccess = ({ zone, slots, locations, homeInspectionExpressSlotAvailable,
    homeInspectionPremiumSlotAvailable }) => ({
    type: Types.FETCH_SLOTS_BY_LOCATIONS_SUCCESS,
    zone,
    slots,
    locations,
    homeInspectionExpressSlotAvailable,
    homeInspectionPremiumSlotAvailable
});

const fetchSlotsFailure = () => ({
    type: Types.FETCH_SLOTS_BY_LOCATIONS_FAILURE
});

const setInspectionType = (selectedInspectionType) => ({
    type: Types.SET_INSPECTION_TYPE,
    selectedInspectionType
});

const setBranch = (selectedBranch) => ({
    type: Types.SET_SELECTED_BRANCH,
    selectedBranch
});

const submitAppointmentSuccess = ({ appointment_id: appointmentID }) => ({
    type: Types.SUBMIT_APPOINTMENT_SUCCESS,
    appointmentID
});

const submitAppointmentFailure = () => ({
    type: Types.SUBMIT_APPOINTMENT_FAILURE
});

const updateAPIStatus = (data) => ({
    type: Types.UPDATE_API_STATUS,
    data
});
const setIsHiAvailable = (isHiAvailable) => ({
    type: Types.SET_IS_HI_AVAILABLE,
    isHiAvailable
});

const createAppointment = (token, params, query, headers) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.createAppointment(token, params, query, headers, true).then(response => {
            dispatch(submitAppointmentSuccess(response.data.detail));
            resolve(response.data.detail);
        }).catch((error) => {
            dispatch(submitAppointmentFailure());
            dispatch(updateAPIStatus(false));
            reject(error);
        });
    });
};

const updateAppointment = (token, params, query, headers) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateAppointment(token, params, query, headers, true).then(response => {
            resolve(response.data.detail);
        }).catch((error) => {
            dispatch(updateAPIStatus(false));
            reject(error);
        });
    });
};

const setInspectionDate = (selectedInspectionDate) => ({
    type: Types.SET_INSPECTION_DATE,
    selectedInspectionDate
});

const setInspectionTime = (selectedInspectionTime) => ({
    type: Types.SET_INSPECTION_TIME,
    selectedInspectionTime
});

const resetSelections = () => ({
    type: Types.RESET_SELECTIONS
});

const fetchSlots = (params) => dispatch => {
    return new Promise((resolve, reject) => {
        dispatch({ type: Types.RESET_SELECTIONS });
        dispatch({ type: Types.FETCH_SLOTS_BY_LOCATIONS });
        carConsumerService.fetchGeoSlots(params).then(response => {
            dispatch(fetchSlotsSuccess(response));
            resolve(response);
        }).catch((e) => {
            dispatch(fetchSlotsFailure());
            reject(e);
        });
    });
};

const sendOTPSuccess = () => ({ type: Types.SEND_OTP_SUCCESS });

const sendOTP = (params) => dispatch => {
    LeadServiceJava.sendOTP(params).then(() => {
        dispatch(sendOTPSuccess());
    });
};

const setEditMode = (isEditMode) => ({
    type: Types.SET_EDIT_MODE,
    isEditMode
});

const setWhatsappNotificationStatus = () => ({
    type: Types.SET_WHATSAPP_NOTIFICATION_STATUS
});

const restoreAppointmentForm = (data) => ({
    type: Types.RESTORE_APPOINTMENT_FORM,
    data
});

const setPrefilledBranch = (prefilledBranch) => ({
    type: Types.SET_PREFILLED_BRANCH,
    prefilledBranch
});

const setPrefilledInspectionType = (prefilledInspectionType) => ({
    type: Types.SET_PREFIIED_INSPECTION_TYPE,
    prefilledInspectionType
});

const setSellBikeConsent = (sellBikeConsent) => ({
    type: Types.SET_SELL_BIKE_CONSENT,
    sellBikeConsent
});

const resetLocationData = () => ({
    type: Types.RESET_LOCATION_DATA
});

const setAddress = (address) => ({
    type: Types.SET_ADDRESS,
    address
});
const setAddressType = (addressType) => ({
    type: Types.SET_ADDRESS_TYPE,
    addressType
});
const setLandmark = (landmark) => ({
    type: Types.SET_LANDMARK,
    landmark
});

const setAppointmentScreen = (appointmentScreen) => ({
    type: Types.SET_APPOINTMENT_SCREEN,
    appointmentScreen
});

const applySelectionsAndData = (data) => ({
    type: Types.APPLY_SELECTIONS_AND_DATA,
    data
});

const setPreviousSelectedZone = (zone) => ({
    type: Types.SET_PREVIOUS_SELECTED_ZONE,
    zone
});

const setAppointmentId = (appointmentId) => ({
    type: Types.SET_APPOINTMENT_ID,
    appointmentId
});

const setInspectionLocation = (inspectionLocation) => ({
    type: Types.SET_INSPECTION_LOCATION,
    inspectionLocation
});

const setLocationName = (locationName) => ({
    type: Types.SET_CURRENT_LOCATION_NAME,
    locationName
});

const setIsLocationSearchEnabled = (isLocationSearchEnabled) => ({
    type: Types.SET_IS_LOCATION_SEARCH_ENABLED,
    isLocationSearchEnabled
});

const setLocation = (location) => ({
    type: Types.SET_LOCATION,
    location
});

const setLocCoords = (locCoords) => ({
    type: Types.SET_LOCATION_COORDS,
    locCoords
});

// eslint-disable-next-line no-unused-vars
const updateGeoDetailsInLead = (payload, token) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateGeoDetailsInLead(payload, token).then(response => {
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};

// eslint-disable-next-line no-unused-vars
const getCarHealthPrice = (token, queryString) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getCarHealthPrice(token, queryString)
            .then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
    });
};

const toggleLocationDrawer = (status) => ({
    type: Types.TOGGLE_LOCATION_DRAWER,
    status
});

export {
    fetchSlots,
    setInspectionType,
    setBranch,
    createAppointment,
    setInspectionDate,
    setInspectionTime,
    sendOTP,
    resetSelections,
    updateAppointment,
    setEditMode,
    updateAPIStatus,
    setWhatsappNotificationStatus,
    restoreAppointmentForm,
    setPrefilledBranch,
    setPrefilledInspectionType,
    setSellBikeConsent,
    resetLocationData,
    setAddress,
    setLandmark,
    setAppointmentId,
    setAppointmentScreen,
    applySelectionsAndData,
    setPreviousSelectedZone,
    submitAppointmentFailure,
    updateGeoDetailsInLead,
    setAddressType,
    setIsHiAvailable,
    setInspectionLocation,
    setLocationName,
    setIsLocationSearchEnabled,
    setLocation,
    setLocCoords,
    getCarHealthPrice,
    toggleLocationDrawer
};
